import { Injectable } from '@angular/core';
import { FormControlStatus, FormGroup, Validators } from '@angular/forms';
import { BaseFpxComponentState, BaseFpxFormHelper, BaseFpxPostSubmitInterceptor, RoutingInfo } from "@fpx/core";
import {
	BaseFpxChangeHandler,
	BaseFpxEventHandler,
	BaseFpxLoadFormHandler,
	CriteriaQuery,
	FindByKeyFn,
	HttpRequest,
} from '@common/models';
import { ChequebookrequestService } from '../chequebookrequest-service/chequebookrequest.service';
import { Chequebookrequest } from '../chequebookrequest-service/chequebookrequest.model';
import { ProcessShellService } from 'src/app/process-shell/services/process-shell.service';
import { AccountsService } from 'src/app/services/accounts/accounts.service';
import { REFERENCE_KEY } from 'src/app/common/constants/base.constant';
import moment from 'moment';



export class AccChequeBookRequestFormState extends BaseFpxComponentState {
	showSuggestion: boolean = false;
	isInitialLoad: any=true;
	isBranchVisible: boolean = false;
	// reqDate!: string;
  reqDate:Date;
  maxDate:Date;
}


@Injectable()
export class AccChequeBookRequestFormHelper extends BaseFpxFormHelper<AccChequeBookRequestFormState>{

	constructor(private accChequeBookRequestFormService: ChequebookrequestService,
		private processService: ProcessShellService,
		private _casaAccountService: AccountsService) {
		super(new AccChequeBookRequestFormState());

	}
  subtractYears(numOfYears, date = new Date()) {
    date.setFullYear(date.getFullYear() - numOfYears);
    return date;
  }

	override doPreInit(): void {
		this.addChangeHandler("accountNumber", this.doaccountNumberChange);
		this.addChangeHandler("dlvryOption", this.dodlvryOptionChange);

		// let startDate = moment().format("YYYY-MM-DD");
				// this.state.reqDate = startDate;
        this.state.reqDate = this.subtractYears(2);
        this.state.maxDate = new Date();
	}

	override doPostInit(): void {
		this.processService.setConfirmationPage(true);
		this.state.isInitialLoad = true;
		let accountNum = this.getRoutingParam(REFERENCE_KEY);
		this.formGroup.patchValue({
			'accountNumber': accountNum,
			'dlvryOption': '1'
		}, {
			emitEvent: false
		});
		if(this.getFormMode() === 'ADD'){
			this.state.isInitialLoad = false;
			this.formGroup.removeControl('inventoryNumber')
		}
	}

	private doaccountNumberChange: BaseFpxChangeHandler = (
		name: string,
		status: FormControlStatus,
		value: Array<any>,
		formGroup: FormGroup
	) => {
		// WRITE CODE HERE TO HANDLE 
		if(!this.state.isInitialLoad){
			formGroup.controls["noOfChqBooks"].reset();
			formGroup.controls["noOfLeaves"].reset();
			formGroup.controls["dlvryOption"].patchValue('1',{emitEvent : false});
			// formGroup.controls["requestDate"].reset(new Date(), {emitEvent: false});
			this.formGroup.controls['requestDate'].patchValue(new Date(), {emitEvent:false});
			this.state.isBranchVisible = true;
			formGroup.controls['dlvryBranch'].enable();
			formGroup.controls["dlvryBranch"].reset();
			formGroup.controls["remarks"].reset();
	 
		   }
	};

	private dodlvryOptionChange: BaseFpxChangeHandler = (
		name: string,
		status: FormControlStatus,
		value: any,
		formGroup: FormGroup
	) => {
		// WRITE CODE HERE TO HANDLE 
		formGroup.controls["dlvryBranch"].reset();
		if (value == '2') {
			formGroup.controls['dlvryBranch'].disable();
			this.state.isBranchVisible = false;
		}
		else if (value == '1') {
			this.state.isBranchVisible = true;
			formGroup.controls['dlvryBranch'].enable();
		}

	};


	public preSubmitForm(payload: any){
		
		this.processService.preSubmitFormEmit.emit();
	}

	public cancelPreSubmitForm(payload: any) {
		console.log(payload)
	}
  

	public override preSubmitInterceptor(payload: Chequebookrequest): any {

		// WRITE CODE HERE TO HANDLE 
		return payload;
	}

	public override postSubmitInterceptor(response: any): RoutingInfo {
		let routingInfo: RoutingInfo = new RoutingInfo();
		// WRITE CODE HERE TO HANDLE 
		// let menuData = this._casaAccountService.getSelectedMenuData('A001');
		// this.processService.processCode = menuData.processCode;
		// this._casaAccountService.triggerFormSubmitCopleted(response.success?.body?.chequebookrequest);
		if (response?.success?.body?.chequebookrequest) {
			this.processService.processId =
			  response?.success?.body?.chequebookrequest?.processId;
		  }
		  this.processService.triggerFormSubmittedCompleteStatus(response);
		return routingInfo;
	}

}